import React, { PureComponent } from 'react';
import _ from 'lodash';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import { wrapperUrlwithEPFToken, isStaticMode, getPathname, isPreview, isThirdPartyTokenAuthorization, getLinkId } from '../utils/general/general';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import $ from 'jquery';

interface IInfographicTemplateProps {
    source: any;
    initialData: any;
    docHeaderSectionJson: any;
    id?: string;
}

export class InfographicTemplate extends PureComponent<IInfographicTemplateProps, any> {

    public infoSetTimeout: any;
    public infographicIframeRef: any;
    public igIdentifier: string | undefined;

    constructor(props: IInfographicTemplateProps) {
        super(props);
        this.infographicIframeRef = React.createRef();
    }

    public componentDidMount() {
        $(window).on('resize', _.debounce(_.bind(this.handleResize, this), 200));
        if (!window.HTML_RENDITION.addedIGMessageListener && this.igIdentifier) {
            this.igListener();
            window.HTML_RENDITION.addedIGMessageListener = true;
        }
        if (isThirdPartyTokenAuthorization()) {
            const infographicIframeEle = $(this.infographicIframeRef.current);
            const IframeSrc = infographicIframeEle?.attr('src');
            IframeSrc && wrapperUrlwithEPFToken(IframeSrc).then((newSrc) => {infographicIframeEle.attr('src', newSrc)});
        }
    }
    public igListener() {
        window.addEventListener("message", (e) => {
            if (e.data.igIdentifier && e.data.igHeight){
                let selector = '.ig_frame_' + e.data.igIdentifier;
                if(e.data.isFG){
                    selector = '.figure-gallery-container ' + selector;
                }
                if (e.data.visW) {
                  const iframeW = $(selector).width() || 0;
                  console.log(iframeW, e.data.visW, '【VIS Canvas】');
                  $(selector).width(Number(e.data.visW) > iframeW ? e.data.visW : '100%'); 
                }
                $(selector).height(e.data.igHeight);
                console.log('Got IG message', e.data.igIdentifier, e.data.igHeight, e.data.isFG);
            }
        }, false);
    }

    public componentWillUnmount() {
        $(window).off('resize', _.debounce(_.bind(this.handleResize, this), 200));
    }

    public isInfogrpahics(obj: any) {
        return (obj.contentWindow?.INFOGRAPHIC === undefined);
    }

    public setInfoIframeSize(obj: any) {
        if (this.igIdentifier){
            const $iframe = $(obj);
            const igIdentifier = this.igIdentifier;
            const isFG = $iframe.closest('.figure-gallery-container').length > 0;
            obj?.contentWindow?.postMessage({igIdentifier, igMethod:'getIGHeight', isFG}, '*');
        } else {
            try {
                const iframe: any = $(obj);
                if (!this.isInfogrpahics(obj)) {
                    const iframeScale = Math.ceil(obj.contentWindow.INFOGRAPHIC.scale * 10) / 10;
                    if (iframe && iframe.contents().find('div').eq(0) && iframe.contents().find('div').eq(0).height()) {
                        iframe.height(Math.ceil(iframe.contents().find('div').eq(0).height() * iframeScale));
                    }
                    return;
                }

                const infographicHeight : number = iframe.contents().find("html").height();
                if (infographicHeight == 0) {
                    // Set a min height 800
                    iframe.height(800);
                } else {
                    iframe.height(infographicHeight);
                }
            } catch (e) {
                console.log(e);
                throw new Error();
            }
        }
    }

    // get infographic_container position
    public infographicPositionFun() {
        const that = this;
        const infogArea1 = parseInt((window.innerHeight / 3 as any), 10);
        const infogArea2 = parseInt((window.innerHeight / 4 as any), 10);
        window.HTML_RENDITION.infographicPositionArr = [];
        $(".infographic_container").map(function () {
            const position = parseInt(($(this).cvOffSet().top - infogArea1 as any), 10);
            window.HTML_RENDITION.infographicPositionArr.push(position);
        });
        window.HTML_RENDITION.infogSection = infogArea2;
        const infographicDom = this.infographicIframeRef.current;
        if (window.HTML_RENDITION.infographicEventNotRegist) {
            window.HTML_RENDITION.windowScrollNotRegist = false;
            window.HTML_RENDITION.windowScroll();
            $("#slider").on('click', function () {
                setTimeout(() => {
                    that.setInfoIframeSize(infographicDom);
                }, 200);
            });
        }
    }

    public handleResize() {
        setTimeout(() => {
            this.setInfoIframeSize(this.infographicIframeRef.current);
            this.infographicPositionFun();
        }, 100);
    }

    public infoloadfun = () => {
        this.setInfoIframeSize(this.infographicIframeRef.current);
        this.infographicPositionFun();

        if (!this.igIdentifier){
            const me = this;
            const iframe: any = $(this.infographicIframeRef.current);
            const max = 30;
            let count = 0;
            if (iframe.contents().find('.vega-visualization').length){
                const id = setInterval(() => {
                    count++;
                    if (iframe.contents().find('.vega-visualization').find('canvas,svg').length || count > max){
                        me.setInfoIframeSize(me.infographicIframeRef.current);
                        me.infographicPositionFun();
                        clearInterval(id);
                    }
                }, 1000);
            }
        }
    }
    
    public renderDom() {
        const { source, initialData, docHeaderSectionJson } = this.props;
        let tempURL = "";
        let tempElement = null;
        let faveIndexPathList = null;
        let faveIndexPath = '';
        let isVisme = '';
        let fileName = '';
        let thumbnailUrl = '';
        let infographicTitle = '';
        infographicTitle = !initialData.isFAVEOrCGI && source.altText;
        let infographicType = "";

        if (initialData.isFAVEOrCGI && docHeaderSectionJson.infographics) {
            faveIndexPathList = docHeaderSectionJson.infographics.data;
            for (let i = 0; i < faveIndexPathList.length; i++ ) {
                const infographicID = initialData.docFileType !== 'HTML' && parseFloat(source.format.class.toUpperCase().split('INFOGRAPHICSID_')[1]);

                let comparedTarget = infographicID;
                if ( initialData.docFileType == 'HTML') {
                    if ( parseFloat(source) ) {
                        comparedTarget = source;
                    } else {
                        if (parseFloat(source?.format?.class?.toUpperCase().split('INFOGRAPHICSID_')[1])) {
                            comparedTarget = parseFloat(source?.format?.class?.toUpperCase().split('INFOGRAPHICSID_')[1]);
                        } else {
                            comparedTarget = source;
                        }
                    }
                }

                if (faveIndexPathList[i].imageId == comparedTarget) {
                    faveIndexPath = faveIndexPathList[i].indexPath;
                    isVisme = faveIndexPathList[i].isVisme;
                    fileName = faveIndexPathList[i].fileName;
                    infographicType = faveIndexPathList[i].type;
                    thumbnailUrl = faveIndexPathList[i].thumbnailUrl;
                    infographicTitle = faveIndexPathList[i].title;
                    break;
                }
            }
        }

        if (isStaticMode()) {
            tempURL = initialData.isFAVEOrCGI ?
            thumbnailUrl
            :
            initialData.unProtectedPath + initialData.doc_id + "/" + source['default'].filename || source['medium'].filename || source['small'].filename;
            tempElement = <img tabIndex={0} role="img" className='infographic_img' src={tempURL} alt="Infographic Image"/>;
        } else if (initialData.isFAVEOrCGI && (isVisme == 'true' || infographicType === 'vegaEmbed') && deviceInfoService.isIE()){
            tempElement = <img tabIndex={0} role="img" className='infographic_img' src={thumbnailUrl} alt="Infographic Image"/>;
        } else {
            tempURL = initialData.isFAVEOrCGI ? faveIndexPath : (source['default'].href || source['medium'].href || source['small'].href);
            tempURL = tempURL ? getPathname(tempURL) : ''; // Remove the hostname to avoid "cross-origin frame" error

            let jointMark = '';
            if (location.search) {
                const searchPara = location.search.substr(1);
                jointMark = tempURL.indexOf('?') < 0 ? '?' : '&';
                tempURL = tempURL + jointMark + searchPara;
            }

            if (tempURL.indexOf('doc_id') < 0) {
                jointMark = tempURL.indexOf('?') < 0 ? '?' : '&';
                tempURL = tempURL + jointMark + "doc_id=" + initialData.doc_id;
            }

            if (initialData.isFAVEOrCGI){
                if (fileName){
                    this.igIdentifier = fileName;
                } else {
                    const akprotected = `/rendition/akprotected/documents/output/${initialData.doc_id}/infographics/`;
                    const index = tempURL.indexOf(akprotected);
                    if (index > -1){
                        const arr = tempURL.substring(index + akprotected.length).split('/');
                        if (arr && arr.length > 0 && arr[0]){
                            this.igIdentifier = arr[0];
                        }
                    }
                }
                if (initialData.isFAVE && !isPreview()){
                    if (this.igIdentifier){
                        tempURL = `/rendition/eppublic/uiservices/openInfographics?doc_id=${initialData.doc_id}&infographicsId=${this.igIdentifier}&isOutputIG=true`;
                        if(window.HTML_RENDITION.initialData.isTimedLinkAvailable){
                            tempURL = `/rendition/eppublic/service/openInfographics?doc_id=${initialData.doc_id}&infographicsId=${this.igIdentifier}&isOutputIG=true&linkId=${getLinkId()}`;
                        }
                    } else {
                        tempURL = this.getHeaderJsonLikeURL(tempURL);
                    }
                }
            }
            let clazz = 'infographic_iframe';
            if(this.igIdentifier){
                clazz += ` ig_frame_${this.igIdentifier}`;
            }
            // test in local open below url
            // tempURL = "http://localhost:9090/rendition/documents/infographics/1/index.html";
            // For FAVE: http://localhost:9090/rendition/documents/preview/output/8131/infographics/739/index.html
            // Or you can add infographic folders under /public, so that you can debug it:
            // tempURL = 'http://localhost:3000/infographics/1/index.html';
            // Visme infographics test
            // tempURL = "http://localhost:9090/rendition/documents/infographics/202020220432/output/index.html";
            tempElement = <iframe ref={this.infographicIframeRef} onLoad={this.infoloadfun} className={clazz} frameBorder='0' scrolling='no' src={tempURL} title={infographicTitle}></iframe>;
        }

        return (
            <span id={this.props.id} className='infographic_container'>
                {tempElement}
            </span>
        );
    }

    public getHeaderJsonLikeURL = (tempURL: string) => {
        const initialData = this.props.initialData;
        const jointMark = tempURL.indexOf('?') < 0 ? '?' : '&';
        const timeStamp = (window.HTML_RENDITION.initialData.isNewOutput) ? initialData.extractionCompletionMillisec : initialData.buildTimeStamp;
        let p = `id=${initialData.id}&parent_doc_id=${initialData.parent_doc_id}&rendition_doc_id=${initialData.doc_id}&ts=${timeStamp}&version=${initialData.version}`;
        if (tempURL.indexOf('doc_id') < 0) {
            p = `id=${initialData.id}&parent_doc_id=${initialData.parent_doc_id}&doc_id=${initialData.doc_id}&rendition_doc_id=${initialData.doc_id}&ts=${timeStamp}&version=${initialData.version}`;
        }
        return tempURL + jointMark + p;
    }

    public render() {
        return this.renderDom();
    }

}

const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
    };
};

export default connect(mapStateToProps)(InfographicTemplate);
